import React from 'react';
import StickyBox from 'components/StickyBox';
function StickyEditorPageHeaderWrapper(_ref) {
  var _ref$mb = _ref.mb,
    mb = _ref$mb === void 0 ? 'm' : _ref$mb,
    distance = _ref.distance,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(StickyBox, {
    placement: "top",
    borderRadius: "large",
    mb: mb,
    distance: distance
  }, children);
}
export default StickyEditorPageHeaderWrapper;